module.exports = __webpack_public_path__ + "static/media/softwaredevelopmentheading.4984c0ac.gif";